<template>
	<div class="content">
    <base-header class="pb-6">
	<div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("profile.info") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
				<route-breadcrumb />
			</nav>
        </div>

       
      </div>
	</base-header>

	<div class="container-fluid mt--6">
  <card>
    <div slot="header" class="row align-items-center">
      <div class="col-8">
        <h3 class="mb-0">Edit profile </h3>
      </div>
    </div>

	<validation-observer ref="formValidator">
    <form @submit.prevent="updateProfile">
      <div class="pl-lg-4">
        <div class="row">
          <div class="col-lg-6">
            <base-input
              type="text"
			  rules="required"
              :label="$t('fname')"
              :name="$t('fname')"
              v-model="params.fname"
            >
            </base-input>
          </div>
		</div>
		<div class="row">
			<div class="col-lg-6">
            <base-input
              type="text"
			  rules="required"
              :label="$t('lname')"
              :name="$t('lname')"
              v-model="params.lname"
            >
            </base-input>
          </div>
        </div>
		<div class="row">
			<div class="col-lg-6">
            <base-input
              type="text"
			  rules="required"
              :label="$t('nick_name')"
              :name="$t('nick_name')"
              v-model="params.nick_name"
            >
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              type="text"
			  rules="required|numeric"
              :label="$t('phone')"
              :name="$t('phone')"
              v-model="params.phone"
            >
            </base-input>
          </div>
        </div>

		<div class="row">
		  <div class="col-lg-6">
			<base-button
			  type="primary"
			  size="md"
			  @click="updateProfile"
			  >Save</base-button>
		  </div>
		</div>
	  </div>


     

    </form>
	</validation-observer>
  </card>
  </div>
  </div>
</template>
<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';
import BaseButton from '../../components/BaseButton.vue';
import swal from 'sweetalert2';
export default {
  components: { BaseButton },
  data() {
    return {
      params: {
		fname : "",
		lname : "",
		email : "",
		phone : "",
		address : "",
		district_id : "",
		city_id : "",
		province_id : "",
		zipcode : "",
		nick_name:"",
		}
    };
  },
  computed:{
	...mapGetters({
		Profile: 'Auth/getUser',
	})

  },
  mounted(){
	this.params.fname = this.Profile.fname;
	this.params.lname = this.Profile.lname;
	this.params.email = this.Profile.email;
	this.params.phone = this.Profile.phone;
	this.params.nick_name = this.Profile.nick_name;
	// this.params.address = this.Profile.address;
	// this.params.district_id = this.Profile.district_id;
	// this.params.city_id = this.Profile.city_id;
	// this.params.province_id = this.Profile.province_id;
	// this.params.zipcode = this.Profile.zipcode;
  },
  methods: {
	...mapActions({
		changeProfile: 'Auth/changeProfile',
		changePassword:'Auth/changePassword',
		getProfile:'Auth/getProfile',
		setProfile:'Auth/setProfile'
	}),

    updateProfile() {
		if (this.$refs.formValidator.validate()) {
			this.changeProfile(this.params).then((resp) => {
				swal.fire({
					title: 'Success',
					text: 'Profile has been updated',
					icon: 'success',
					confirmButtonText: 'OK'
				});

				this.getProfile().then((resp) => {
					console.log(resp)
					this.setProfile(resp.data.Datum);
				}).catch((err) => {
					console.log(err);
				})


				// this.$router.push({ name: 'BOOrders' });
			}).catch((err)=>{
				swal.fire({
					title: 'Error',
					text: err,
					icon: 'error',
					confirmButtonText: 'OK'
				});
			});
		}
    }
  }
};
</script>
<style></style>
